export enum MmxTrafficSource {
    Direct = "Direct",
    Email = "Email",
    Referrals = "Referrals",
    SocialOrganic = "Social - Organic",
    SocialPaid = "Social - Paid",
    OrganicSearch = "Search - Organic",
    PaidSearch = "Search - Paid",
    Display = "Display Ads",
    GenAi = "Gen AI",
    Affiliates = "Affiliates",
}

export interface IMmxTrafficSources {
    [key: string]: number;
    [MmxTrafficSource.Direct]: number;
    [MmxTrafficSource.Email]: number;
    [MmxTrafficSource.Referrals]: number;
    [MmxTrafficSource.SocialOrganic]: number;
    [MmxTrafficSource.SocialPaid]: number;
    [MmxTrafficSource.OrganicSearch]: number;
    [MmxTrafficSource.PaidSearch]: number;
    [MmxTrafficSource.GenAi]: number;
    [MmxTrafficSource.Display]: number;
    [MmxTrafficSource.Affiliates]: number;
}
